import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
		POST 	/api/owners
	*/
    postAddNewOwner: function(child_id, name,role, mobile,email,card,permission,document,expiry,_default ){
        return axios.post( LOGUS_CONFIG.API_URL + '/owners',
            {
                child_id:child_id,
                name: name,
                role:role,
                mobile:mobile,
                email:email,
                card:card,
                permission:permission,
                document:document,
                expiry:expiry,
                default:_default
            }
        );
    },

    /*
		GET 	/api/owners/{slug}/edit
	*/
    getOwnerEdit: function( slug){
		return axios.get( LOGUS_CONFIG.API_URL + '/owners/' + slug + '/edit' );
    },
    
    /*
		POST 	/api/owners/{slug}/copy
	*/
    postCopyOwner: function( slug){
		return axios.post( LOGUS_CONFIG.API_URL + '/owners/' + slug + '/copy' );
	},

    /*
		PUT 	/api/owners/{slug}
	*/
    putEditOwner: function(slug,child_id,  name,role,mobile,email,card,permission,document,expiry,_default){
        return axios.put( LOGUS_CONFIG.API_URL + '/owners/'+ slug,
            {
                child_id:child_id,
                name: name,
                role:role,
                mobile:mobile,
                email:email,
                card:card,
                permission:permission,
                document:document,
                expiry:expiry,
                default:_default
            }
        );
    },

  /*
		PUT 	/api/owners/{slug}/addUser
	*/
  putAddUserToOwner: function(slug,user_id,password){
    return axios.put( LOGUS_CONFIG.API_URL + '/owners/'+ slug + '/addUser',
        {
            user_id:user_id,
            password: password,
        }
    );
  },

  /*
		PUT 	/api/owners/{slug}/deleteUser
	*/
  putDeleteUserFromOwner: function(slug){
    return axios.put( LOGUS_CONFIG.API_URL + '/owners/'+ slug + '/deleteUser');
  },

  /*
		PUT 	/api/owners/{slug}/resetUserPassword
	*/
  putResetUserPassword: function(slug,password){
    return axios.put( LOGUS_CONFIG.API_URL + '/owners/'+ slug + '/reseteUserPassword',
        {
            password: password,
        }
    );
  },

    
    /*
		DELETE /api/owners/{slug}/force
	*/
    forceDeleteOwner: function( slug, year_id ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/owners/' + slug + '/force' );
    }
}